"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _OffenseInformationCard_offenseData_accessor_storage, _OffenseInformationCard_cardTitle_accessor_storage, _OffenseInformationCard_subTitle_accessor_storage, _OffenseInformationCard_includeCardTitle_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffenseInformationCard = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let OffenseInformationCard = class OffenseInformationCard extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _OffenseInformationCard_offenseData_accessor_storage.set(this, []);
        _OffenseInformationCard_cardTitle_accessor_storage.set(this, 'Offense Information');
        _OffenseInformationCard_subTitle_accessor_storage.set(this, '');
        _OffenseInformationCard_includeCardTitle_accessor_storage.set(this, true);
    }
    get offenseData() { return __classPrivateFieldGet(this, _OffenseInformationCard_offenseData_accessor_storage, "f"); }
    set offenseData(value) { __classPrivateFieldSet(this, _OffenseInformationCard_offenseData_accessor_storage, value, "f"); }
    get cardTitle() { return __classPrivateFieldGet(this, _OffenseInformationCard_cardTitle_accessor_storage, "f"); }
    set cardTitle(value) { __classPrivateFieldSet(this, _OffenseInformationCard_cardTitle_accessor_storage, value, "f"); }
    get subTitle() { return __classPrivateFieldGet(this, _OffenseInformationCard_subTitle_accessor_storage, "f"); }
    set subTitle(value) { __classPrivateFieldSet(this, _OffenseInformationCard_subTitle_accessor_storage, value, "f"); }
    get includeCardTitle() { return __classPrivateFieldGet(this, _OffenseInformationCard_includeCardTitle_accessor_storage, "f"); }
    set includeCardTitle(value) { __classPrivateFieldSet(this, _OffenseInformationCard_includeCardTitle_accessor_storage, value, "f"); }
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, lit_1.html) `
      <forge-card raised>
          <div>
            ${this.includeCardTitle ? (0, lit_1.html) `<div class="forge-typography--heading5" style="margin-bottom: 10px; font-weight: bold">${this.cardTitle}</div>` : (0, lit_1.html) ``}
          <div>
            ${this.subTitle ??
            (0, lit_1.html) `<div .aria-label=${this.subTitle} class="forge-typography--body2" style="color: grey">
              ${this.subTitle}
            </div>`}
           ${this.includeCardTitle ? (0, lit_1.html) `<forge-divider style="margin-bottom: 10px;"></forge-divider>` : (0, lit_1.html) ``}
          </div>
          ${this.offenseData.map((item) => {
            return (0, lit_1.html) `
                <div style="display: grid; grid-template-columns: repeat(7, 1fr); grid-column-gap: 20%; margin-bottom: 10px; white-space: nowrap">
                  <forge-label-value>
                    <forge-label slot="label">Statute</forge-label>
                    <forge-label slot="value">${item.offenseCodeSection}</forge-label>
                  </forge-label-value>
                  <forge-label-value>
                    <forge-label slot="label">Count</forge-label>
                    <forge-label slot="value">${item.counts}</forge-label>
                  </forge-label-value>
                  <forge-label-value>
                    <forge-label slot="label">Class</forge-label>
                    <forge-label slot="value">${item.offenseLevel}</forge-label>
                  </forge-label-value>
                  <forge-label-value>
                    <forge-label slot="label">Description</forge-label>
                    <forge-label slot="value">${item.offenseCodeSectionDescription}</forge-label>
                  </forge-label-value>
                </div>
              `;
        })}
      </forge-card>
    `;
    }
};
exports.OffenseInformationCard = OffenseInformationCard;
_OffenseInformationCard_offenseData_accessor_storage = new WeakMap();
_OffenseInformationCard_cardTitle_accessor_storage = new WeakMap();
_OffenseInformationCard_subTitle_accessor_storage = new WeakMap();
_OffenseInformationCard_includeCardTitle_accessor_storage = new WeakMap();
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], OffenseInformationCard.prototype, "offenseData", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], OffenseInformationCard.prototype, "cardTitle", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], OffenseInformationCard.prototype, "subTitle", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], OffenseInformationCard.prototype, "includeCardTitle", null);
exports.OffenseInformationCard = OffenseInformationCard = __decorate([
    (0, decorators_js_1.customElement)("sup-offense-information-card")
], OffenseInformationCard);
